// extracted by mini-css-extract-plugin
export default {"wrapper":"jgSnJUf4hCES8_4ewuO0"};